var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDeactivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.554,
    height: 26.299,
    viewBox: "0 0 20.554 26.299"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-deactivate_svg__cls-5{fill:none}.kpmg-deactivate_svg__cls-2{stroke:#ff7f00;stroke-linecap:round;stroke-width:1.6px;stroke-linejoin:round;fill:#ff7f00}.kpmg-deactivate_svg__cls-4{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__kpmg-deactivate",
    "data-name": "KPMG Deactivate",
    transform: "translate(-188 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__Rectangle_419",
    "data-name": "Rectangle 419",
    transform: "translate(188 260)",
    strokeLinejoin: "round",
    stroke: "#ff7f00",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.149,
    height: 26.299,
    className: "kpmg-deactivate_svg__cls-4",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.549,
    height: 24.699,
    x: 0.8,
    y: 0.8,
    className: "kpmg-deactivate_svg__cls-5",
    rx: 3.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__Ellipse_195",
    className: "kpmg-deactivate_svg__cls-2",
    "data-name": "Ellipse 195",
    transform: "translate(192.404 264.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.67,
    cy: 3.67,
    r: 3.67,
    className: "kpmg-deactivate_svg__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.67,
    cy: 3.67,
    r: 2.87,
    className: "kpmg-deactivate_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__Rectangle_420",
    className: "kpmg-deactivate_svg__cls-2",
    "data-name": "Rectangle 420",
    transform: "translate(195.341 266.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.213,
    height: 2.404,
    className: "kpmg-deactivate_svg__cls-4",
    rx: 1.202
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.613,
    height: 0.804,
    x: 0.8,
    y: 0.8,
    className: "kpmg-deactivate_svg__cls-5",
    rx: 0.402
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__Group_1424",
    "data-name": "Group 1424",
    transform: "rotate(180 99.06 140.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate_svg__Ellipse_164",
    className: "kpmg-deactivate_svg__cls-2",
    "data-name": "Ellipse 164",
    transform: "translate(0 1.118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.01,
    cy: 2.01,
    r: 2.01,
    className: "kpmg-deactivate_svg__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.01,
    cy: 2.01,
    r: 1.21,
    className: "kpmg-deactivate_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate_svg__Line_82",
    d: "M2.01-1.212v3.49",
    "data-name": "Line 82",
    stroke: "#ff7f00",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  })))));
}

export default SvgKpmgDeactivate;